const defaultConsts = {
  userManagement: {
    defaultAdminUserName: "admin",
  },
  localization: {
    defaultLocalizationSourceName: "jinxinong",
  },
  authorization: {
    encrptedAuthTokenName: "enc_auth_token",
  },
  appBaseUrl: "http://localhost:8080",
  remoteServiceBaseUrl: "https://mall.api.jinxinong.com",
  token_root: "https://mall.auth.jinxinong.com",
  response_type: "id_token token",
  scope:
    "IdentityService VipService ProductService OrderService AlbumService MarketingService MallConfigService ArticleService DistributionService offline_access openid",
};

let env =
  process.env.NODE_ENV === "development"
    ? "development"
    : process.env.VUE_APP_TITLE === "alpha"
    ? "alpha"
    : "production";
switch (env) {
  case "development":
    // 测试站点
    // defaultConsts.appBaseUrl = "http://localhost:8080";
    defaultConsts.appBaseUrl = "http://localhost:8080";
    // defaultConsts.remoteServiceBaseUrl = "https://mall.api.jinxinong.com";
    defaultConsts.remoteServiceBaseUrl = "/api";
    defaultConsts.token_root = "https://mall.auth.jinxinong.com";
    break;
  case "production":
    // 正式站点
    defaultConsts.appBaseUrl = "https://mall.admin.jinxinong.com";
    defaultConsts.remoteServiceBaseUrl = "https://mall.api.jinxinong.com";
    defaultConsts.token_root = "https://mall.auth.jinxinong.com";
    break;
  case "alpha":
    // 测试站点
    defaultConsts.appBaseUrl = "https://mall.admin.jinxinong.com";
    defaultConsts.remoteServiceBaseUrl = "https://mall.api.jinxinong.com";
    defaultConsts.token_root = "https://mall.auth.jinxinong.com";
    break;
}

export default defaultConsts;
